const PrivacyPage = () => {
  return (
    <div className="relative z-10 min-h-screen bg-gradient-to-b from-white via-gray-50 to-white py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-[900px] mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary/10 text-primary rounded-full mb-6 font-semibold text-sm">
              <i className="fas fa-shield-alt"></i>
              <span>سياسة الخصوصية</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-black text-text mb-4">
              سياسة الخصوصية
            </h1>
            <p className="text-xl text-text2">
              آخر تحديث: مارس 2026
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-3xl shadow-xl border-2 border-gray-100 p-8 md:p-12 space-y-10">
            {/* Section 1 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-primary rounded-full"></span>
                المقدمة
              </h2>
              <p className="text-lg text-text2 leading-relaxed">
                نحن في منصة Allemni نلتزم بحماية خصوصيتك. توضح سياسة الخصوصية هذه كيفية جمع واستخدام وحماية المعلومات الشخصية التي تقدمها عند استخدام منصتنا التعليمية.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-secondary rounded-full"></span>
                المعلومات التي نجمعها
              </h2>
              <div className="space-y-4 text-lg text-text2">
                <p className="leading-relaxed">نقوم بجمع المعلومات التالية:</p>
                <ul className="space-y-3 mr-6">
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-primary mt-1"></i>
                    <span><strong>معلومات الحساب:</strong> الاسم، البريد الإلكتروني، كلمة المرور المشفرة</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-primary mt-1"></i>
                    <span><strong>معلومات الاستخدام:</strong> تقدمك في الدورات، الوقت المستغرق، الصفحات المشاهدة</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-primary mt-1"></i>
                    <span><strong>معلومات الدفع:</strong> معلومات المعاملات المالية (لا نحفظ بيانات البطاقة)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-check text-primary mt-1"></i>
                    <span><strong>معلومات تقنية:</strong> عنوان IP، نوع المتصفح، نظام التشغيل</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-accent rounded-full"></span>
                كيفية استخدام المعلومات
              </h2>
              <div className="space-y-4 text-lg text-text2">
                <p className="leading-relaxed">نستخدم معلوماتك للأغراض التالية:</p>
                <ul className="space-y-3 mr-6">
                  <li className="flex items-start gap-3">
                    <i className="fas fa-arrow-left text-secondary mt-1"></i>
                    <span>توفير وإدارة خدماتنا التعليمية</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-arrow-left text-secondary mt-1"></i>
                    <span>تحسين تجربة المستخدم وتطوير المنصة</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-arrow-left text-secondary mt-1"></i>
                    <span>إرسال إشعارات حول الدورات والتحديثات</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-arrow-left text-secondary mt-1"></i>
                    <span>معالجة المدفوعات والاشتراكات</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="fas fa-arrow-left text-secondary mt-1"></i>
                    <span>ضمان أمان المنصة ومنع الاحتيال</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-green-500 rounded-full"></span>
                حماية البيانات
              </h2>
              <p className="text-lg text-text2 leading-relaxed mb-4">
                نحن نتخذ إجراءات أمنية صارمة لحماية معلوماتك الشخصية:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="p-4 bg-green-50 rounded-xl border border-green-200">
                  <i className="fas fa-lock text-green-600 text-2xl mb-2"></i>
                  <h3 className="font-bold text-text mb-1">تشفير البيانات</h3>
                  <p className="text-sm text-text3">جميع البيانات مشفرة أثناء النقل والتخزين</p>
                </div>
                <div className="p-4 bg-blue-50 rounded-xl border border-blue-200">
                  <i className="fas fa-server text-blue-600 text-2xl mb-2"></i>
                  <h3 className="font-bold text-text mb-1">خوادم آمنة</h3>
                  <p className="text-sm text-text3">استخدام Cloudflare لأقصى درجات الأمان</p>
                </div>
              </div>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-purple-500 rounded-full"></span>
                مشاركة المعلومات
              </h2>
              <p className="text-lg text-text2 leading-relaxed">
                نحن <strong>لا نبيع أو نشارك</strong> معلوماتك الشخصية مع أطراف ثالثة إلا في الحالات التالية:
              </p>
              <ul className="space-y-3 mr-6 mt-4 text-lg text-text2">
                <li className="flex items-start gap-3">
                  <i className="fas fa-minus text-text3 mt-1"></i>
                  <span>عند الحصول على موافقتك الصريحة</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="fas fa-minus text-text3 mt-1"></i>
                  <span>مع مزودي خدمات الدفع (Chargily) لمعالجة المعاملات</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="fas fa-minus text-text3 mt-1"></i>
                  <span>عندما يتطلب القانون الجزائري ذلك</span>
                </li>
              </ul>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-orange-500 rounded-full"></span>
                حقوقك
              </h2>
              <p className="text-lg text-text2 leading-relaxed mb-4">
                لديك الحقوق التالية بخصوص بياناتك الشخصية:
              </p>
              <div className="space-y-3 bg-orange-50 p-6 rounded-xl border border-orange-200">
                <div className="flex items-center gap-3">
                  <i className="fas fa-eye text-orange-600"></i>
                  <span className="text-lg text-text">الوصول إلى معلوماتك الشخصية</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fas fa-edit text-orange-600"></i>
                  <span className="text-lg text-text">تعديل أو تحديث بياناتك</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fas fa-trash text-orange-600"></i>
                  <span className="text-lg text-text">طلب حذف حسابك وبياناتك</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fas fa-download text-orange-600"></i>
                  <span className="text-lg text-text">تحميل نسخة من بياناتك</span>
                </div>
              </div>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-red-500 rounded-full"></span>
                ملفات تعريف الارتباط (Cookies)
              </h2>
              <p className="text-lg text-text2 leading-relaxed">
                نستخدم ملفات تعريف الارتباط لتحسين تجربتك على المنصة. يمكنك إدارة تفضيلات ملفات تعريف الارتباط من خلال إعدادات المتصفح الخاص بك.
              </p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl md:text-3xl font-black text-text mb-4 flex items-center gap-3">
                <span className="w-2 h-8 bg-pink-500 rounded-full"></span>
                التواصل معنا
              </h2>
              <p className="text-lg text-text2 leading-relaxed mb-4">
                إذا كان لديك أي أسئلة حول سياسة الخصوصية، يمكنك التواصل معنا عبر:
              </p>
              <div className="flex flex-col gap-3 bg-gray-50 p-6 rounded-xl">
                <div className="flex items-center gap-3">
                  <i className="fas fa-envelope text-primary"></i>
                  <span className="text-lg" dir="ltr">info@allemani.dz</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fas fa-phone text-primary"></i>
                  <span className="text-lg" dir="ltr">0558501409</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
